module.exports = __webpack_public_path__ + "static/media/49.5a05961f.jpg";